// extracted by mini-css-extract-plugin
export var dropdownButton = "_6k-0";
export var iconPlaceholder = "_6k-1";